<template>
  <div class="h-100 w-100">
    <slot name="default" :item="item">
    </slot>
  </div>
</template>

<script>

export default {
  name: 'NxDataGridItem',
  props: {
    item: {
      type: Object,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/datagrid/NxDataGridItem.vue